/** Public registration page paths, shared by routes, guards and the HTTP interceptor. */
export const AUTH_ROUTES = {
  signUp: '/auth/sign-up',
  verifyOtp: '/auth/verify-otp'
} as const;
